var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOutlinedWithoutPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.004 171.609V142.061C398.004 63.6028 334.401 0 255.943 0C177.485 0 113.883 63.6028 113.883 142.06V171.608C76.5579 190.656 53.0457 229.004 53 270.908V372.38C53.0675 433.998 103.001 483.932 164.619 483.999H347.268C408.885 483.931 458.819 433.998 458.886 372.38V270.909C458.841 229.005 435.329 190.656 398.004 171.609ZM255.943 60.883C300.776 60.883 337.12 97.2273 337.12 142.06V159.29H174.766V142.06C174.766 97.2273 211.11 60.883 255.943 60.883ZM398.004 372.38C398.004 400.401 375.289 423.116 347.269 423.116H164.619C136.599 423.116 113.884 400.401 113.884 372.38V270.909C113.884 242.889 136.599 220.174 164.619 220.174H347.269C375.289 220.174 398.004 242.889 398.004 270.909V372.38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutlinedWithoutPoint);
export default __webpack_public_path__ + "static/media/lock-outlined-without-point.5ce465e514abf70919324e3392b6f6d5.svg";
export { ForwardRef as ReactComponent };